<div class="error" *ngFor="let error of errors">
  {{ error }}
</div>
